import { CardComp } from "../..";

/**
 * Page header aligned with other staff admin modules (Contribution, Withdrawal Requests).
 */
export default function InvestorPortalPageHeader({ title, subtitle, action }) {
  return (
    <CardComp cardClassName="border-0 shadow-sm mb-3">
      <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-3 py-1">
        <div>
          <h3 className="text-black1 fw-bold mb-0" style={{ fontSize: "1.35rem", color: "#45464E" }}>
            {title}
          </h3>
          {subtitle ? <p className="text-muted small mb-0 mt-1">{subtitle}</p> : null}
        </div>
        {action ? <div className="flex-shrink-0">{action}</div> : null}
      </div>
    </CardComp>
  );
}

export function InvestorPortalPrimaryButton({ btnText, onClick, loading }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={loading}
      className="btn fw-bold text-white border-0"
      style={{
        minWidth: 180,
        height: 50,
        borderRadius: 10,
        backgroundColor: "var(--color-primary)",
        whiteSpace: "nowrap",
      }}
    >
      {loading ? "Loading..." : btnText}
    </button>
  );
}
